module.exports = __webpack_public_path__ + "media/members/upload_spreadsheet-b4e1c4b4.png";